"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantType = void 0;
var GrantType;
(function (GrantType) {
    GrantType["RefreshToken"] = "refreshToken";
    GrantType["AuthorizationCode"] = "authorizationCode";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
/**
 * @see https://api-reference.kevin.eu/public/platform/v0.3#tag/Authentication-Service
 */
class AuthService {
    constructor(client) {
        this._client = client;
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/startAuth
     */
    authenticate(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this._client.sendRequest(AuthService.ROUTES.AUTHENTICATE, 'post', { headers: options.headers, queryParameters: options.query });
            if (!options.lang) {
                return response;
            }
            const authorizationLink = new URL(String(response.authorizationLink));
            authorizationLink.searchParams.append('lang', String(options.lang));
            response.authorizationLink = authorizationLink.toString();
            return response;
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/receiveToken
     */
    receiveToken(code) {
        const body = {
            grantType: GrantType.AuthorizationCode,
            code,
        };
        return this._client.sendRequest(AuthService.ROUTES.RECEIVE_TOKEN, 'post', { body });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/receiveToken
     */
    refreshToken(refreshToken) {
        const body = {
            grantType: GrantType.RefreshToken,
            refreshToken,
        };
        return this._client.sendRequest(AuthService.ROUTES.REFRESH_TOKEN, 'post', { body });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/receiveTokenContent
     */
    receiveTokenContent(token) {
        return this._client.sendRequest(AuthService.ROUTES.TOKEN_CONTENT, 'get', { bearerToken: token });
    }
}
AuthService.ROUTES = {
    AUTHENTICATE: '/auth',
    RECEIVE_TOKEN: '/auth/token',
    REFRESH_TOKEN: '/auth/token',
    TOKEN_CONTENT: '/auth/token/content',
};
exports.default = AuthService;
